import { Module } from 'vuex';
import { IRootState } from '@/store';
import { InvoiceStateEnum } from '@/models';
import { IInvoiceGetters, IInvoiceState } from './invoice.types';

export const state: IInvoiceState = {
  version: 1,
  invoiceStateVisuals: [
    {
      value: InvoiceStateEnum.Draft,
      text: 'Draft',
      color: 'draft',
      icon: 'mdi-file-document-outline'
    },
    {
      value: InvoiceStateEnum.Approved,
      text: 'Approved',
      color: 'approved',
      icon: 'mdi-check'
    },
    {
      value: InvoiceStateEnum.Sent,
      text: 'Sent',
      color: 'submitted',
      icon: 'mdi-send'
    },
    {
      value: InvoiceStateEnum.Paid,
      text: 'Paid',
      color: 'done',
      icon: 'mdi-cash'
    },
    {
      value: InvoiceStateEnum.Cancelled,
      text: 'Cancelled',
      color: 'cancel',
      icon: 'mdi-cancel'
    }
  ]
};

export const getters: IInvoiceGetters = {
  getInvoiceStateVisuals: (state: IInvoiceState) => state.invoiceStateVisuals,
  getInvoiceStateVisualByState: (state: IInvoiceState) => (
    paymentStateEnum: InvoiceStateEnum
  ) => {
    return state.invoiceStateVisuals.find(
      stateVisual => stateVisual.value == paymentStateEnum
    );
  }
};

const namespaced = true;

export const invoice: Module<IInvoiceState, IRootState> = {
  namespaced,
  state,
  getters
};
